import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="progress">
      <div className="inner"></div>
      <div className="inner"></div>
      <div className="inner"></div>
      <div className="inner"></div>
      <div className="inner"></div>
    </div>
  );
};

export default Loader;
